import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function CrossIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m16.01 19.5 8.76 8.75a2.48 2.48 0 0 0 3.5-3.5L19.52 16l8.75-8.75a2.47 2.47 0 1 0-3.5-3.5L16 12.5 7.26 3.76a2.48 2.48 0 1 0-3.5 3.5L12.5 16l-8.75 8.75a2.47 2.47 0 1 0 3.5 3.5L16 19.5Z"
        clipRule="evenodd"
      />
    </BaseIcon>
  );
}
